import BannerCard from '@component/BannerCard'
import { Box, Divider } from '@mui/material'
import { ReactNode } from 'react'

interface Props {
  renderInput?: ReactNode
  renderOutput?: ReactNode
}

function Content ({ renderInput, renderOutput }: Props) {
  const columnClassNames = 'flex flex-col gap-12 flex-1 my-8 w-[24rem] min-w-[15rem]'

  return (
    <>
      <Box className={columnClassNames}>
        <BannerCard />
        {renderInput}
      </Box>
      <Divider orientation="vertical" />
      <Box className={columnClassNames}>
        {renderOutput}
        <BannerCard />
      </Box>
    </>
  )
}

export default Content
